<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close('Cross click')"
        [disabled]="showProgressBar"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <form [formGroup]="modalForm">
                <div class="row">
                    <div class="col-md-12 mt-2">
                        <div class="input-group">
                            <input id="importperforma" formControlName="txtFile" type="file"
                                class="form-control form-control-sm" 
                                (change)="onChangeFileSelect($event)" />
                            <button type="button" class="btn btn-primary btn-sm d-flex" (click)="uploadFile()">
                                <i class="bx bx-upload font-size-15 me-1"></i>
                                Upload
                            </button>
                        </div>
                        <ng-container *ngIf="showProgressBar">
                            <div class="progress mt-2">
                                <div class="progress-bar progress-bar-striped" role="progressbar"
                                    [style.width.%]="progress" [attr.aria-valuenow]="progress" aria-valuemin=" 0"
                                    aria-valuemax="100">
                                    {{progress}}%
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>